import { Box, Table } from '@mui/material';

import { TableOverlaySpinner } from '~/components/Spinner/TableOverlaySpinner';
import { generateTableRowsSkeleton, TableBody } from '~/components/Table';
import { EmptyTableContent } from '~/components/Table/EmptyTableContent';
import { useCachedData } from '~/hooks/useCachedData';
import { Customer } from '~/types/customer';
import { SortDirection } from '~/types/table';

import { headCells } from './config';
import { TableHead } from './TableHead';
import { TableRow } from './TableRow';

export type Props = {
  items?: Customer[];
  isLoading?: boolean;
  currentSort?: keyof Customer | string;
  sortDirection?: SortDirection;
  onSort: (column: keyof Customer | string) => void;
};

export const CustomersTable = ({
  items,
  isLoading = false,
  currentSort,
  sortDirection,
  onSort,
}: Props) => {
  const cached = useCachedData<Customer[]>(items);

  return (
    <Table>
      <TableHead
        headCells={headCells}
        currentSort={currentSort}
        sortDirection={sortDirection}
        onSort={onSort}
      />

      <TableBody isEmpty={!!cached?.length}>
        {generateTableRowsSkeleton(headCells, isLoading && !cached, true)}

        {cached?.map((row) => (
          <TableRow key={row.id} row={row} />
        ))}

        {!cached?.length && !isLoading && (
          <EmptyTableContent headCells={headCells} hasCheckbox>
            <Box
              component="img"
              sx={{
                height: 300,
                width: 300,
                maxHeight: { xs: 160, md: 300 },
                maxWidth: { xs: 160, md: 300 },
                resize: 'cover',
              }}
              alt="The house from the offer."
              src={require('../../../assets/images/Clients.png')}
            />
          </EmptyTableContent>
        )}

        {!!cached?.length && isLoading && <TableOverlaySpinner />}
      </TableBody>
    </Table>
  );
};
